import React from "react"
import { Box, Typography } from "@mui/material"
import { DANGER, DANGER_TINT, KPI_TILE_BG, PANEL_TEXT_FAINT } from "@/theme/tokens"
import { KPI_VALUE_SX, ROW_DESCRIPTION_SX } from "@/theme/panelStyles"

const SMALL_TEXT = ROW_DESCRIPTION_SX.fontSize

export const KPI_TILE_SX = {
  background: KPI_TILE_BG,
  borderRadius: "8px",
  p: "7px 9px",
  minWidth: 0,
}

// Fine and light so the value stays in focus.
export const KPI_LABEL_SX = { ...ROW_DESCRIPTION_SX, lineHeight: 1.4 }

// Exceeded state, spread into KpiTile props; compares the shown (rounded) value so "5.0 m / limit 5.0" never turns red.
export const limitTone = (value, limit, format) =>
  limit > 0 && value != null && Number(format(value)) > limit
    ? { tone: "danger", limitLabel: `limit ${format(limit)}` }
    : {}

// One tile layout for all KPIs: label (+ adornment) / value + unit / optional sub line.
export default function KpiTile({
  label,
  value,
  unit,
  valueColor = KPI_VALUE_SX.color,
  subValue,
  subValueColor = PANEL_TEXT_FAINT,
  limitLabel = null,
  adornment = null,
  tone = null,
  sx,
}) {
  const danger = tone === "danger"
  const empty = value == null || value === ""
  return (
    <Box sx={{ ...KPI_TILE_SX, ...(danger ? { background: DANGER_TINT } : null), ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 0.5, minHeight: 14 }}>
        <Typography noWrap sx={{ ...KPI_LABEL_SX, ...(danger ? { color: DANGER } : null) }}>
          {label}
        </Typography>
        {adornment}
      </Box>
      <Typography
        sx={{
          ...KPI_VALUE_SX,
          lineHeight: 1.35,
          color: empty ? PANEL_TEXT_FAINT : danger ? DANGER : valueColor,
          fontVariantNumeric: "tabular-nums",
          whiteSpace: "pre-line",
        }}
      >
        {empty ? "–" : value}
        {!empty && unit ? (
          <Box component="span" sx={{ fontSize: SMALL_TEXT, fontWeight: 500, ml: 0.4, color: danger ? DANGER : PANEL_TEXT_FAINT }}>
            {unit}
          </Box>
        ) : null}
      </Typography>
      {subValue && (
        <Typography noWrap sx={{ fontSize: SMALL_TEXT, lineHeight: 1.4, color: danger ? DANGER : subValueColor }}>
          {subValue}
        </Typography>
      )}
      {limitLabel && (
        <Typography noWrap sx={{ fontSize: SMALL_TEXT, lineHeight: 1.4, fontWeight: 700, color: DANGER }}>
          {limitLabel}
        </Typography>
      )}
    </Box>
  )
}
